export default "__VITE_ASSET__vXXsNth___"